/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:43
 * @LastEditors: linxi
 * @LastEditTime: 2024-10-18 14:14:45
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { RootThunkApi } from '../../../../app/store'
import { sendAsync } from '../../../../app/applicationSlice'
import { getdrugTradeCodeList, getTraceCodeScanRateList, getTraceCodeUploadRateList, ScanRateListParams, UploadRateListParams } from '../../../../services/selfRateInquiry'

export const getTraceCodeScanRateListAsync = createAsyncThunk<
  void,
  ScanRateListParams,
  RootThunkApi
>('TraceCodeScanRate/getTreceCodeScanRateList', async (params, api) => {
  return sendAsync(getTraceCodeScanRateList(params), api)
})

export const getTraceCodeUploadRateListAsync = createAsyncThunk<
  void,
  UploadRateListParams,
  RootThunkApi
>('TraceCodeScanRate/getTreceCodeUploadRateList', async (params, api) => {
  return sendAsync(getTraceCodeUploadRateList(params), api)
})

export const getdrugTradeCodeListAsync = createAsyncThunk<
  void,
  UploadRateListParams,
  RootThunkApi
>('TraceCodeScanRate/getdrugTradeCodeListAsync', async (params, api) => {
  return sendAsync(getdrugTradeCodeList(params), api)
})